import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/stand-personalizado-nfc")({
  beforeLoad: () => {
    throw redirect({ href: "/stand-personalizado-nfc-qr", statusCode: 301 });
  },
});
